import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axiosClient from "../../api/axiosClient";
import ContentEditor from "./components/ContentEditor";

const initialForm = {
    title: "",
    slug: "",
    status: "draft",
    description: "",
    content: "",
    featuredImage: "",
    projectUrl: "",
};

const EditProject = () => {
    const { projectId } = useParams();
    const navigate = useNavigate();
    const [form, setForm] = useState(initialForm);
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState("");
    const [apiError, setApiError] = useState("");
    
    useEffect(() => {
        fetchProject();
        // eslint-disable-next-line
    }, [projectId]);
    
    const fetchProject = async () => {
        setApiError("");
        try {
            const res = await axiosClient.get(`/projects/${projectId}`);
            const d = res.data.data;
            setForm({
                title: d.title || "",
                slug: d.slug || "",
                status: d.status || "draft",
                description: d.description || "",
                content: d.content || "",
                featuredImage: d.featuredImage || "",
                projectUrl: d.projectUrl || "",
            });
        } catch (err) {
            setApiError("Failed to fetch project.");
        }
    };
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);
        setApiError("");
        setMessage("");
        try {
            await axiosClient.put(`/projects/${projectId}`, {
                ...form,
                status: form.status || "draft",
            });
            setMessage("Project updated!");
            setTimeout(() => navigate("/projects"), 1200);
        } catch (err) {
            setApiError(
                err.response?.data?.message || "Failed to update project. Please try again."
            );
        } finally {
            setSaving(false);
        }
    };
    
    return (
        <div className="container mt-4" style={{ maxWidth: "850px" }}>
            <h2 className="mb-4">Edit Project</h2>
            {apiError && <div className="alert alert-danger">{apiError}</div>}
            {message && <div className="alert alert-success">{message}</div>}
            
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label className="form-label">Title</label>
                    <input
                        className="form-control"
                        name="title"
                        value={form.title}
                        onChange={handleChange}
                        required
                    />
                </div>
                
                <div className="mb-3">
                    <label className="form-label">Slug</label>
                    <input
                        className="form-control"
                        name="slug"
                        value={form.slug}
                        onChange={handleChange}
                        required
                    />
                </div>
                
                <div className="mb-3">
                    <label className="form-label">Status</label>
                    <select
                        className="form-select"
                        name="status"
                        value={form.status}
                        onChange={handleChange}
                    >
                        <option value="draft">Draft</option>
                        <option value="published">Published</option>
                    </select>
                </div>
                
                <div className="mb-3">
                    <label className="form-label">Description</label>
                    <textarea
                        className="form-control"
                        name="description"
                        value={form.description}
                        onChange={handleChange}
                        rows={2}
                    />
                </div>
                
                <div className="mb-3">
                    <label className="form-label">Featured Image URL</label>
                    <input
                        className="form-control"
                        name="featuredImage"
                        value={form.featuredImage}
                        onChange={handleChange}
                    />
                </div>
                
                <div className="mb-3">
                    <label className="form-label">Project URL</label>
                    <input
                        className="form-control"
                        name="projectUrl"
                        value={form.projectUrl}
                        onChange={handleChange}
                    />
                </div>
                
                <div className="mb-3">
                    <label className="form-label">Content</label>
                    <ContentEditor
                        value={form.content}
                        onChange={(content) =>
                            setForm((prev) => ({ ...prev, content }))
                        }
                    />
                </div>
                
                <button type="submit" className="btn btn-primary" disabled={saving}>
                    {saving ? "Saving..." : "Update Project"}
                </button>
            </form>
        </div>
    );
};

export default EditProject;
